{
    "Profile_Dwellings_Improvement.improvement": "Improvement",
    "Profile_Dwellings_Improvement.improvementDetails": "Improvement Details",
    "Profile_Dwellings_Improvement.description": "Description",
    "Profile_Dwellings_Improvement.value": "Value"
}
